import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { getDriverSession, registerDriverPushToken, saveDriverSession } from "../lib/driverSession";

export default function DriverLoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (getDriverSession()?.auth_token) return <Navigate to="/delivery" replace />;

  async function login(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await api("/delivery/login", {
        method: "POST",
        body: JSON.stringify(form),
      });
      if (!response?.success || !response?.data?.auth_token) {
        throw new Error("El usuario no pertenece al equipo de reparto o la contraseña es incorrecta.");
      }
      saveDriverSession(response.data);
      registerDriverPushToken(response.data);
      navigate("/delivery", { replace: true });
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="driver-login">
      <section>
        <img src="/assets/img/logos/logo.png" alt="Delivery Huaraz" />
        <small>APP DE MOTOS Y CONDUCTORES</small>
        <h1>Panel de reparto</h1>
        <p>Usa la cuenta asignada por Delivery Huaraz. Los pedidos, envíos y viajes aparecen dentro de este panel.</p>
        <form onSubmit={login}>
          <label>Correo<input type="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} required /></label>
          <label>Contraseña<input type="password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} required /></label>
          {error && <div className="checkout-error">{error}</div>}
          <button disabled={busy} type="submit">{busy ? "Ingresando…" : "Ingresar al panel"}</button>
        </form>
        <a href="/inicio">← Volver a Delivery Huaraz</a>
      </section>
    </main>
  );
}
